// 病房dlg组件

const wardDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    branchId: '',

    wardId: '',

    wardName: '',

    projectId: ''
  },

  getters: {
    dlgShow: state => state.dlgShow,

    branchId: state => state.branchId,

    wardId: state => state.wardId,

    wardName: state => state.wardName,

    projectId: state => state.projectId,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_BRANCHID: (state, val) => {
      state.branchId = val
    },

    SET_WARDID: (state, val) => {
      state.wardId = val
    },

    SET_WARDNAME: (state, val) => {
      state.wardName = val
    },

    SET_PROJECTID: (state, val) => {
      state.projectId = val
    }
  },

  actions: {

  }
}

export default wardDlg
